// extracted by mini-css-extract-plugin
export default {"banner":"OWypHs"};